import { useCallback, useMemo } from "react";
import { generatePath, useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

type Props = {
	hotelID: string;
};

export const useNavigateToCampaignPage = ({ hotelID }: Props) => {
	const navigate = useNavigate();

	const createNewCampaignPagePath = useMemo(
		() => generatePath(PATHS.HOTEL.MARKETING.CAMPAIGN.NEW, { hotelID }),
		[hotelID],
	);

	const editCampaignPagePath = useCallback(
		(campaignID: string) => generatePath(PATHS.HOTEL.MARKETING.CAMPAIGN.EDIT, { hotelID, campaignID }),
		[hotelID],
	);

	const detailsPagePath = useCallback(
		(campaignID: string) => generatePath(PATHS.HOTEL.MARKETING.CAMPAIGN.DETAILS, { hotelID, campaignID }),
		[hotelID],
	);

	const navigateToCreateNewCampaignPage = useCallback(() => {
		navigate(createNewCampaignPagePath);
	}, [createNewCampaignPagePath, navigate]);

	const navigateToEditOrDetailsPage = useCallback(
		(voucherID: string, inSale: boolean) => {
			inSale ? navigate(detailsPagePath(voucherID)) : navigate(editCampaignPagePath(voucherID));
		},
		[detailsPagePath, editCampaignPagePath, navigate],
	);

	const navigateToEditPage = useCallback(
		(voucherID: string) => {
			navigate(editCampaignPagePath(voucherID));
		},
		[editCampaignPagePath, navigate],
	);

	return {
		navigateToCreateNewCampaignPage,
		navigateToEditOrDetailsPage,
		navigateToEditPage,
	};
};
